// Function to initialize currency rates
export const initializeCurrencyRates = async () => {
  try {
    const response = await fetch('/api/currencies');
    const rates = await response.json();
    
    if (response.ok && rates) {
      // Store rates on window object for global access
      window.currencyRates = rates;
      return rates;
    } else {
      throw new Error('Failed to fetch currency rates');
    }
  } catch (error) {
    // Fallback to default rates if API call fails
    window.currencyRates = {
      'EUR': 1,
      'GBP': 0.86,
      'USD': 1.08,
      'ILS': 3.98
    };
    return window.currencyRates;
  }
};

// Function to convert amount between currencies
export const convertCurrency = (amount, from, to) => {
  if (!window.currencyRates) {
    console.warn('Currency rates not initialized');
    return amount;
  }
  return amount / window.currencyRates[from] * window.currencyRates[to];
};

// Function to get currency symbol
export const getCurrencySymbol = (currency) => {
  switch (currency) {
    case 'GBP':
      return '£';
    case 'USD':
      return '$';
    case 'ILS':
      return '₪';
    case 'EUR':
    default:
      return '€';
  }
}; 